import styled from 'styled-components';
import DownloadIcon from '../../../../new-components/svg-icons/DownloadIcon';
import useDownloadPDF from '../../hooks/DownloadPDF';

const DownloadButton = () => {
  const { downloadPDF, isDownloading } = useDownloadPDF();
  return (
    <Container onClick={downloadPDF}>
      {isDownloading ? (
        <i className="spinner" />
      ) : (
        <DownloadIcon
          width="24px"
          height="24px"
          stroke="#4B535F"
          strokeWidth="2"
        />
      )}
    </Container>
  );
};

const Container = styled.button`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  background-color: #fff;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.04),
    0px 4px 8px 0px rgba(0, 0, 0, 0.06);
  border: none;
  border-radius: 360px;

  .spinner {
    border: 4px solid rgba(255, 255, 255, 0.2);
    border-top: 4px solid #ffffff;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    width: 40px;
    height: 40px;
  }
`;

export default DownloadButton;
